import DashboardLoader from '@/components/RedesignComponents/PageLoaders/DashboardLoader.vue'
import DashboardSettingsLoader from '@/components/RedesignComponents/PageLoaders/DashboardSettingsLoader.vue'
import DashboardLayoutSettingsLoader
    from '@/components/RedesignComponents/PageLoaders/DashboardLayoutSettingsLoader.vue'
import DashboardCreationLoader from '@/components/RedesignComponents/PageLoaders/DashboardCreationLoader.vue'

export default {
    DashboardLoader,
    DashboardSettingsLoader,
    DashboardLayoutSettingsLoader,
    DashboardCreationLoader
}
